<template>
    <div class="container">
        <section class="section">
            <div class="section__content">
                <div class="d-flex flex-column flex-md-row justify-content-between col-12 px-0">
                    <div class="col-12 p-0">
                        <div>
                            <div class="col-12 col-md-6 col-lg-8 px-0 pr-md-4">
                                <div class="u-mb-3">
                                    <button class="btn btn--tertiary-icon-before p-0 text--black" type="button"
                                            data-loading="false" aria-expanded="false" to="[object Object]">
                                        <div class="d-flex flex-row justify-content-center align-items-center  flex-gap-12">
                                            <div>
                                                <svg viewBox="0 0 24 24" class="icon icon--16">
                                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                                          d="M15.7071 5.29289C16.0976 5.68342 16.0976 6.31658 15.7071 6.70711L10.4142 12L15.7071 17.2929C16.0976 17.6834 16.0976 18.3166 15.7071 18.7071C15.3166 19.0976 14.6834 19.0976 14.2929 18.7071L8.29289 12.7071C7.90237 12.3166 7.90237 11.6834 8.29289 11.2929L14.2929 5.29289C14.6834 4.90237 15.3166 4.90237 15.7071 5.29289Z"></path>
                                                </svg>
                                            </div>
                                            <div>
                                                <div class="text--xs text--uppercase">Add funds</div>
                                            </div>
                                        </div>
                                    </button>
                                    <div class="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center flex-gap-16">
                                        <div class="d-flex flex-gap-8 align-items-center u-mt-0-5 u-mb-lg-1">
                                            <div class="h2 font-weight--bold u-mb-0 line-height--h3">All virtual
                                                accounts
                                            </div>
                                        </div>
                                        <div class="text--md d-lg-none">Select how to add funds to your account</div>
                                    </div>
                                    <div class="text--md d-none d-lg-block">Select how to add funds to your account
                                    </div>
                                </div>
                                <div class="d-flex justify-content-between u-p-2 border-bottom--light hovered-table-row"
                                     role="button" tabindex="0">
                                    <div class="d-flex align-items-center"><img
                                            src="/static/media/usa-image243dae8e510eeaf5632f.png" alt="USD image"
                                            class="thumb--40">
                                        <div class="ml-3">
                                            <div class="font-weight--bold">United States</div>
                                            <div class="text--sm">Wire / ACH</div>
                                        </div>
                                    </div>
                                    <button class="btn--icon btn--icon--primary btn--icon--sm text--black"
                                            type="button">
                                        <svg viewBox="0 0 24 24" class="icon icon--24">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                  d="M8.29289 5.29289C8.68342 4.90237 9.31658 4.90237 9.70711 5.29289L15.7071 11.2929C16.0976 11.6834 16.0976 12.3166 15.7071 12.7071L9.70711 18.7071C9.31658 19.0976 8.68342 19.0976 8.29289 18.7071C7.90237 18.3166 7.90237 17.6834 8.29289 17.2929L13.5858 12L8.29289 6.70711C7.90237 6.31658 7.90237 5.68342 8.29289 5.29289Z"></path>
                                        </svg>
                                    </button>
                                </div>
                                <div class="d-flex justify-content-between u-p-2 border-bottom--light hovered-table-row"
                                     role="button" tabindex="0">
                                    <div class="d-flex align-items-center"><img
                                            src="/static/media/eur-image76afcde4e4b3ec8e837a.png" alt="EUR image"
                                            class="thumb--40">
                                        <div class="ml-3">
                                            <div class="font-weight--bold">Europe</div>
                                            <div class="text--sm">IBAN</div>
                                        </div>
                                    </div>
                                    <button class="btn--icon btn--icon--primary btn--icon--sm text--black"
                                            type="button">
                                        <svg viewBox="0 0 24 24" class="icon icon--24">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                  d="M8.29289 5.29289C8.68342 4.90237 9.31658 4.90237 9.70711 5.29289L15.7071 11.2929C16.0976 11.6834 16.0976 12.3166 15.7071 12.7071L9.70711 18.7071C9.31658 19.0976 8.68342 19.0976 8.29289 18.7071C7.90237 18.3166 7.90237 17.6834 8.29289 17.2929L13.5858 12L8.29289 6.70711C7.90237 6.31658 7.90237 5.68342 8.29289 5.29289Z"></path>
                                        </svg>
                                    </button>
                                </div>
                                <div class="bg--neutrals-30 pt-2"></div>
                                <div class="d-flex justify-content-between u-p-2 border-bottom--light hovered-table-row"
                                     role="button" tabindex="0">
                                    <div class="d-flex align-items-center"><img
                                            src="/static/media/col-imagea643051e4b23ff51a05c.png" alt="COP image"
                                            class="thumb--40">
                                        <div class="ml-3">
                                            <div class="font-weight--bold">Colombia</div>
                                            <div class="text--sm">Bre-b</div>
                                        </div>
                                    </div>
                                    <button class="btn--icon btn--icon--primary btn--icon--sm text--black"
                                            type="button">
                                        <svg viewBox="0 0 24 24" class="icon icon--24">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                  d="M8.29289 5.29289C8.68342 4.90237 9.31658 4.90237 9.70711 5.29289L15.7071 11.2929C16.0976 11.6834 16.0976 12.3166 15.7071 12.7071L9.70711 18.7071C9.31658 19.0976 8.68342 19.0976 8.29289 18.7071C7.90237 18.3166 7.90237 17.6834 8.29289 17.2929L13.5858 12L8.29289 6.70711C7.90237 6.31658 7.90237 5.68342 8.29289 5.29289Z"></path>
                                        </svg>
                                    </button>
                                </div>
                                <div class="d-flex justify-content-between u-p-2 border-bottom--light hovered-table-row"
                                     role="button" tabindex="0">
                                    <div class="d-flex align-items-center"><img
                                            src="/static/media/mex-image464d0e75d05e7339b654.png" alt="MXN image"
                                            class="thumb--40">
                                        <div class="ml-3">
                                            <div class="font-weight--bold">Mexico</div>
                                            <div class="text--sm">SPEI</div>
                                        </div>
                                    </div>
                                    <button class="btn--icon btn--icon--primary btn--icon--sm text--black"
                                            type="button">
                                        <svg viewBox="0 0 24 24" class="icon icon--24">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                  d="M8.29289 5.29289C8.68342 4.90237 9.31658 4.90237 9.70711 5.29289L15.7071 11.2929C16.0976 11.6834 16.0976 12.3166 15.7071 12.7071L9.70711 18.7071C9.31658 19.0976 8.68342 19.0976 8.29289 18.7071C7.90237 18.3166 7.90237 17.6834 8.29289 17.2929L13.5858 12L8.29289 6.70711C7.90237 6.31658 7.90237 5.68342 8.29289 5.29289Z"></path>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import Vue from "vue";
    import Fetch from "@/utils/fetch";

    export default {
        name: "index",
        data() {
            return {

            }
        },
        mounted() {

        },
        methods: {
            goToDetail(id) {
                this.$router.push(`/operations/${id}`)
            }
        },
    }
</script>

<style scoped>

</style>